import { createSelector } from 'reselect'
import { selectAffordability } from 'src/store/selectors/buyerInfo'

export const selectYlopoMaxPrice = createSelector(
  selectAffordability,
  affordability => affordability * 1.2
)

export const selectYlopoMinPrice = createSelector(
  selectAffordability,
  affordability => affordability * 0.8
)

export const selectYlopoUrl = state => state.ylopo.ylopoUrl
